// carousel.js - Smooth Looping Dawn-Compatible Carousel

function initCustomCarousel(sectionId) {
  const track = document.getElementById(`carousel-track-${sectionId}`);
  const nextBtn = document.getElementById(`next-${sectionId}`);
  const prevBtn = document.getElementById(`prev-${sectionId}`);

  if (!track) return;

  let slides = track.querySelectorAll('.carousel-slide');
  const total = slides.length;

  // --- CLONE FIRST AND LAST SLIDE FOR SMOOTH LOOP ---
  const firstClone = slides[0].cloneNode(true);
  const lastClone = slides[total - 1].cloneNode(true);

  track.appendChild(firstClone);
  track.insertBefore(lastClone, slides[0]);

  slides = track.querySelectorAll('.carousel-slide');
  let index = 1;

  const slideWidth = 100; // vw
  const autoMs = 5000;

  // Start centered on the first real slide
  track.style.transform = `translateX(-${index * slideWidth}vw)`;

  function moveTo(newIndex) {
    index = newIndex;
    track.style.transition = "transform 0.5s ease-in-out";
    track.style.transform = `translateX(-${index * slideWidth}vw)`;
  }

  // Handle looping instantly *after* animation finishes
  track.addEventListener("transitionend", () => {
    if (slides[index].isEqualNode(firstClone)) {
      track.style.transition = "none";
      index = 1;
      track.style.transform = `translateX(-${index * slideWidth}vw)`;
    }
    if (slides[index].isEqualNode(lastClone)) {
      track.style.transition = "none";
      index = total;
      track.style.transform = `translateX(-${index * slideWidth}vw)`;
    }
  });

  // BUTTON: Next
  if (nextBtn) {
    nextBtn.addEventListener("click", () => {
      if (index >= slides.length - 1) return;
      moveTo(index + 1);
    });
  }

  // BUTTON: Previous
  if (prevBtn) {
    prevBtn.addEventListener("click", () => {
      if (index <= 0) return;
      moveTo(index - 1);
    });
  }

  // AUTO-PLAY
  setInterval(() => {
    if (index >= slides.length - 1) return;
    moveTo(index + 1);
  }, autoMs);
}

function loadAllCarousels() {
  document.querySelectorAll('.custom-carousel').forEach(carousel => {
    const id = carousel.id.replace('carousel-', '');
    initCustomCarousel(id);
  });
}

document.addEventListener('DOMContentLoaded', loadAllCarousels);

document.addEventListener('shopify:section:load', event => {
  const section = event.target;
  const carousel = section.querySelector('.custom-carousel');
  if (carousel) {
    const id = carousel.id.replace('carousel-', '');
    initCustomCarousel(id);
  }
});
